<button class="border border-neutral-200 rounded-xl w-[180px]" (click)="onClick()" mat-ripple>
  @if (image) {
    <img [src]="image" alt="" class="h-[90px] w-full object-cover rounded-t-xl" loading="lazy" />
  } @else {
    <div class="h-[90px] w-full object-cover rounded-t-xl bg-neutral-200"></div>
  }
  <div class="p-3 text-start">
    <p class="text-sm font-semibold">
      {{ title }}
    </p>
    <p class="text-sm font-semibold">
      {{ description }}
    </p>
  </div>
</button>
